import { render, staticRenderFns } from "./DeliveryIncomeByHub.vue?vue&type=template&id=265d61e2&lang=pug&"
import script from "./DeliveryIncomeByHub.vue?vue&type=script&lang=ts&"
export * from "./DeliveryIncomeByHub.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryIncomeByHub.vue?vue&type=style&index=0&id=265d61e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports